// extracted by mini-css-extract-plugin
export default {"articleCard":"article_articleCard__UpE2S","articleImage":"article_articleImage__u32VY","content":"article_content__-IR9d","readMore":"article_readMore__URLT2"};